// extracted by mini-css-extract-plugin
module.exports = {"instagram":"da51a739f7--instagram--DQkhz","instagram__title":"da51a739f7--instagram__title--NFBVj"};